import { render, staticRenderFns } from "./SvgSprite.vue?vue&type=template&id=be2e3378&scoped=true"
import script from "./SvgSprite.vue?vue&type=script&lang=js"
export * from "./SvgSprite.vue?vue&type=script&lang=js"
import style0 from "./SvgSprite.vue?vue&type=style&index=0&id=be2e3378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2e3378",
  null
  
)

export default component.exports